import PropTypes from 'prop-types';
import React from 'react';
import ReactHtml from 'components/shared/ReactHtml';

const TextView = ({ body }) => {
  if (!body) return null;
  return (
    <>
      <ReactHtml THE_DATA_HAS_BEEN_SANITIZED>{body}</ReactHtml>
    </>
  );
};

TextView.propTypes = {
  body: PropTypes.string,
};

export default TextView;
